// extracted by mini-css-extract-plugin
export default {"cp_root":"cp_root___sKNP5","cp_page":"cp_page___RFdQm","cp_tabs":"cp_tabs___Y_m11","content":"content___XEsxs"};